import React, { useEffect, useState } from "react";
import "./alert.css";
import instance from "../../ApiInstance/Inetrceptor";
import {
  Drawer,
  Grid,
  Checkbox,
  Button,
  InputLabel,
  FormControl,
  TextField,
  InputAdornment,
  Typography,
  Alert,
  Table,
  Paper,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableFooter,
  Skeleton,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CancelIcon from "@mui/icons-material/Cancel";
import CustomTheme from "../../Customtheme/Themes"
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import StyledTableCell from "../../Tabletheme/Customtableheader";

const AlertTypesAdd = ({ isOpen, setIsopen, handleClose, getAlterTypes ,GetHandlingData}) => {
  const { drawerWidth, isXs, isSm, isMd, isLg, isXl } = CustomTheme();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showmoreLoader, setShowmoreLoader] = useState(false);
  const [backDrop, setBackDrop] = useState(false);
  const [loader, setLoader] = useState(true);
  const [statusData, setStatusDataData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [totalRecods, setTotalRecods] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [isMessageType, setIsMessageType] = useState(0);
  const [isAlwaysLogged, setIsAlwaysLogged] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [handlingdata, setHandlingdata] = useState([]);
  const [alertTypeAdd, setAlertTypeAdd] = useState({
    alert_type_id: 0,
    alert_type_name: "",
    alert_type_desc: "",
    alert_category_id: 0,
    alert_category_name: null,
    alert_retry_num: "",
    alert_retry_interval: "",
    is_always_logged: 0,
    associated_message_status_id: 0,
    message_status_name:null,
    show_for_message_type: 0,
  });
console.log("handlingdata",handlingdata);
const handleRowSelect = (row) => {
  const selectedIndex = selectedRows.indexOf(row);
  
  let newSelected = [];

  if (selectedIndex === -1) {
    newSelected = newSelected.concat(selectedRows, row);
  } else if (selectedIndex === 0) {
    newSelected = newSelected.concat(selectedRows.slice(1));
  } else if (selectedIndex === selectedRows.length - 1) {
    newSelected = newSelected.concat(selectedRows.slice(0, -1));
  } else if (selectedIndex > 0) {
    newSelected = newSelected.concat(
      selectedRows.slice(0, selectedIndex),
      selectedRows.slice(selectedIndex + 1)
    );
  }

  setSelectedRows(newSelected);
};
console.log("selectedIndex",selectedRows);
  const handleinputChange = (event) => {
    const { id, value } = event.target;
    let sanitizedValue;
    if (id === "alert_retry_num") {
      sanitizedValue = value.replace(/[^0-9]/g, "").slice(0, 2);
    } else if (id === "alert_retry_interval") {
      sanitizedValue = value.replace(/[^0-9]/g, "").slice(0, 5);
    } else {
      sanitizedValue = value;
    }
  
    setAlertTypeAdd((prevData) => ({
      ...prevData,
      [id]: sanitizedValue,
    }));
  };
  
  
  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    if (name === "messageTypeCheckbox") {
      setIsMessageType(checked ? 1 : 0);
    } else if (name === "alwaysLoggedCheckbox") {
      setIsAlwaysLogged(checked ? 1 : 0);
    }
  };
  const getStatusCode = () => {
    const body = {
      id: "",
      searchtext: "",
    };
    instance
      .post("api/v1/Master/MessageStatus/Get", body)
      .then((res) => {
        if (res?.data?.Success) {
          console.log("rest",res?.data?.Value);
          setTotalRecods(res?.data?.Records ?? 0);
          setStatusDataData(() => {
            return [...(res?.data?.Value ?? {})];
          });
        } else {
          setTotalRecods(0);
          setStatusDataData((prevData) => {
            return [...prevData];
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
        setShowmoreLoader(false);
      });
  };
  const getCategory = () => {
    const body = {
      id: "",
      searchtext: "",
    };
    instance
      .post("api/v1/Master/AlertCategory/Get", body)
      .then((res) => {
        if (res?.data?.Success) {
          setTotalRecods(res?.data?.Records ?? 0);
          setCategoryData(() => {
            return [...(res?.data?.Value ?? {})];
          });
        } else {
          setTotalRecods(0);
          setCategoryData((prevData) => {
            return [...prevData];
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
        setShowmoreLoader(false);
      });
  };
  const CreateAlertType = (event) => {
    event.stopPropagation();
    setIsopen(true);
    const handlename = alertTypeAdd?.alert_type_name?.trim();
    const Category = alertTypeAdd?.alert_category_id;
    const Messagestatus = alertTypeAdd?.associated_message_status_id;
    if (!handlename || !Category || !Messagestatus) {
      setError("Please enter Mandatory Fields.");
      setTimeout(() => {
        handleCloseErrorcode();
      }, 5000);
    } else {
      setBackDrop(true);
      const selectedIds = selectedRows.map(row => row.alert_handling_track_id);

      const body = {
        alert_type_id: 0,
        alert_type_name: alertTypeAdd.alert_type_name,
        alert_type_desc: alertTypeAdd.alert_type_desc,
        alert_category_id: alertTypeAdd.alert_category_id,
        alert_retry_num: alertTypeAdd.alert_retry_num,
        alert_retry_interval: alertTypeAdd.alert_retry_interval,
        is_always_logged: isAlwaysLogged,
        associated_message_status_id: alertTypeAdd.associated_message_status_id,
        show_for_message_type: isMessageType,
        alert_handling_track_id: selectedIds.join(','),
      };
      instance
        .post("api/v1/Master/AlertType/Post", body)
        .then((res) => {
          console.log("resp", res);
          if (res?.data?.Success) {
            setError("");
            setSuccess(res?.data?.ResultMessage);
            setIsMessageType(0);
            setIsAlwaysLogged(0);
            setSelectedRows([]);
            getAlterTypes(1);
            setTimeout(() => {
              setSuccess(null);
            }, 5000);
          } else {
            setError(res?.data?.ResultMessage);
            setTimeout(() => {
              setError(null);
            }, 5000);
          }
          setAlertTypeAdd({
            alert_type_id: 0,
            alert_type_name: "",
            alert_type_desc: "",
            alert_category_id: 0,
            alert_retry_num: "",
            alert_retry_interval: "",
            is_always_logged: 0,
            associated_message_status_id: 0,
            show_for_message_type: 0,
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setBackDrop(false);
        });
    }
  };
  const handleCloseErrorcode = () => {
    setError("");
  };
  useEffect(() => {
    getStatusCode();
    getCategory();
  }, []);
  const tableData = async ()=>{
    let data= await  GetHandlingData(false);
    setHandlingdata(data?.data?.Value?? []);
    console.log("handlingdata",data);
  }
  useEffect(() => {
    tableData()
  }, []);
 
  return (
    <Drawer
      anchor="right"
      open={isOpen}
      PaperProps={{
        sx: {
          width: drawerWidth,
        },
      }}
    >
      <div
        style={{ padding: "20px" }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              id="back-button"
              variant="contained"
              color="transparent"
              className="button_backAlert"
              onClick={handleClose}
              startIcon={<ArrowBackIcon  onClick={handleClose}/>}
            >
              Back
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h5"
              className="font-colorAlert mb-0"
              style={{ fontWeight: "600" }}
            >
              Add Alert Type{" "}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h7"
              className="font-colorAlert mb-1"
              style={{ fontWeight: "600" }}
            >
              Alert Type Information{" "}
            </Typography>
          </Grid>
          {error && (
            <Alert
              variant="outlined"
              severity="error"
              icon={<CancelIcon onClick={handleCloseErrorcode} />}
              className="errorAlert mt-4"
            >
              {error}
            </Alert>
          )}
          {success && (
            <Alert
              variant="outlined"
              severity="success"
              className="sucessAlert mt-4"
            >
              {success}
            </Alert>
          )}
          <Grid item xs={12}>
            <InputLabel htmlFor="alert_type_name">Alert Name<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              id="alert_type_name"
              size="small"
              variant="outlined"
              value={alertTypeAdd?.alert_type_name}
              onChange={(event) => handleinputChange(event)}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="alert_type_desc">Description</InputLabel>
            <TextField
              id="alert_type_desc"
              size="small"
              multiline
              rows={4}
              variant="outlined"
              value={alertTypeAdd?.alert_type_desc}
              onChange={(event) => handleinputChange(event)}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="autocomplete-search">Category<span style={{ color: "red" }}>*</span></InputLabel>
            <FormControl variant="outlined" fullWidth>
              <Autocomplete
                id="autocomplete-search"
                options={categoryData}
                getOptionLabel={(option) => option.alert_category_name}
                value={
                  alertTypeAdd.alert_category_id !== 0
                    ? categoryData.find((option) => option.alert_category_id === alertTypeAdd.alert_category_id) || null
                    : null
                }
                onChange={(event, newValue) => {
                  if (newValue) {
                    setAlertTypeAdd((prevData) => ({
                      ...prevData,
                      alert_category_id: newValue.alert_category_id || 0,
                      alert_category_name:newValue.alert_category_name || null
                    }));
                  } else {
                    setAlertTypeAdd((prevData) => ({
                      ...prevData,
                      alert_category_id: 0,
                      alert_category_name:null
                    }));
                  }
                }}
                disableClearable
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="outlined"
                    // InputProps={{
                    //   ...params.InputProps,
                    //   endAdornment: (
                    //     <InputAdornment
                    //       position="end"
                    //       style={{ position: "absolute", right: 20 }}
                    //     >
                    //       <img
                    //         src="assets/Images/searchicon.svg"
                    //         alt="Search Icon"
                    //       />
                    //     </InputAdornment>
                    //   ),
                    // }}
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <InputLabel htmlFor="alert_retry_num">Number of Retries</InputLabel>
            <TextField
              id="alert_retry_num"
              size="small"
              onChange={(event) => handleinputChange(event)}
              value={alertTypeAdd.alert_retry_num}
              variant="outlined"
              fullWidth
              inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <InputLabel htmlFor="alert_retry_interval">
            Retry Interval
            </InputLabel>
            <TextField
              id="alert_retry_interval"
              size="small"
              onChange={(event) => handleinputChange(event)}
              value={alertTypeAdd.alert_retry_interval}
              variant="outlined"
              fullWidth
              inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="autocomplete-search">
              Associated Message Status<span style={{ color: "red" }}>*</span>
            </InputLabel>
            <FormControl variant="outlined" fullWidth>
              <Autocomplete
                id="autocomplete-search"
                options={statusData}
                getOptionLabel={(option) => option.message_status_name}
                value={
                  alertTypeAdd.associated_message_status_id !== 0
                    ? statusData.find((option) => option.message_status_id ===  alertTypeAdd.associated_message_status_id) || null
                    : null
                }
                onChange={(event, newValue) => {
                  if (newValue) {
                    setAlertTypeAdd((prevData) => ({
                      ...prevData,
                      associated_message_status_id:
                        newValue.message_status_id || 0,
                        message_status_name:newValue.message_status_name|| null
                    }));
                  } else {
                    setAlertTypeAdd((prevData) => ({
                      ...prevData,
                      associated_message_status_id: 0,
                      message_status_name:null
                    }));
                  }
                }}
                disableClearable
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="outlined"
                    // InputProps={{
                    //   ...params.InputProps,
                    //   endAdornment: (
                    //     <InputAdornment
                    //       position="end"
                    //       style={{ position: "absolute", right: 20 }}
                    //     >
                    //       <img
                    //         src="assets/Images/searchicon.svg"
                    //         alt="Search Icon"
                    //       />
                    //     </InputAdornment>
                    //   ),
                    // }}
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} className="mb-0">
            <Checkbox
              color="secondary"
              name="messageTypeCheckbox"
              checked={isMessageType}
              onChange={handleCheckboxChange}
            />
            <Typography variant="h7" className="font-colorAlert">
              Appears on Message Type?
            </Typography>
          </Grid>
          <Grid item xs={12} className="mb-1">
            <Checkbox
              color="secondary"
              name="alwaysLoggedCheckbox"
              checked={isAlwaysLogged}
              onChange={handleCheckboxChange}
            />
            <Typography variant="h7" className="font-colorAlert">
              Is Always Logged
            </Typography>
          </Grid>
          <Grid item xs={12}>
          <div style={{ display: "flex" }}>
            <Typography
              variant="h7"
              className="font-color mb-1"
              style={{ fontWeight: "600" }}
            >
              Handling Tracks
            </Typography>
            <p
              style={{ marginLeft: "auto", textDecoration: "underline" }}
            >
              Configure
              <ArrowForwardIcon />
            </p>
          </div>
        </Grid>
          <TableContainer sx={{ margin: 1 , maxHeight: 200}} component={Paper}>
          <Table stickyHeader>
          <TableHead>
              <TableRow className="Table_rowAlert">
                <StyledTableCell> Handling Track ID</StyledTableCell>
                <StyledTableCell />
              </TableRow>
            </TableHead>
            {loader ? (
              <>
                {new Array(2).fill(3).map((element, index) => {
                  return (
                    <TableRow key={index}>
                      {new Array(7).fill(1).map((element, index) => {
                        return (
                          <TableCell align="center" key={index}>
                            <Skeleton
                              variant="rounded"
                              width={"100%"}
                              height={60}
                            />
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </>
            ) : (
              <>
                {handlingdata?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      <p>No Data Found</p>
                    </TableCell>
                  </TableRow>
                ) : (
            <TableBody>
                    {handlingdata.map((row, index) => {
                          const isSelected = selectedRows.indexOf(row) !== -1;
                         return (
                          <TableRow
        key={index}
        // selected={isSelected}
        // onClick={() => handleRowSelect(row)}
        // hover
      >
                        <TableCell
                          style={{ minWidth: "10rem", maxWidth: "10rem" }}
                        >
                          {row.alert_handling_track_name}
                        </TableCell>
                        <TableCell
                          style={{ minWidth: "2rem", maxWidth: "2rem" }}
                        >
                         <Checkbox
            color="secondary"
            checked={isSelected}
            onChange={() => handleRowSelect(row)}
          />
                            </TableCell>
                        </TableRow>  );
                      })}
            </TableBody>
             )}{" "}
             </>
           )}
             {/* <TableFooter>
              <TableRow>
                <TableCell colSpan={2} style={{ textAlign: "center" }}>
                   <Button
                    id="back-button"
                    variant="contained"
                    color="transparent"
                    sx={{
                      display: "flex",
                      justifyContent: "right",
                      marginLeft: "32%",
                      border: "1px solid var(--color-grey)",
                    }}
                  >
                    Add a Handling Track
                  </Button>
                </TableCell>
              </TableRow>
            </TableFooter> */}
          </Table>
        </TableContainer>
          <Grid item xs={12} sx={{ textAlign: "right" }}>
            <Button
              id="back-button"
              variant="contained"
              color="secondary"
              onClick={(event) => CreateAlertType(event)}
            >
              Create
            </Button>
          </Grid>
        </Grid>
      </div>
    </Drawer>
  );
};
export default AlertTypesAdd;
